export default __webpack_public_path__ + "static/media/proposal_no_setting.0518ebc2.svg";